import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AccessProfile,
  AuthSessionState,
  ForgotPasswordRequest,
  LoginRequest,
} from '../../../core/models/auth.model';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<LoginRequest>(),
    'Login Success': props<{
      token: string;
      refreshToken: string | null;
      userName: string;
      role: string;
      publicId: string;
      permissions: string[];
    }>(),
    'Login Failure': props<{ error: string }>(),
    'Tokens Renewed': props<{ token: string; refreshToken: string }>(),
    'Session Expired': props<{ returnUrl: string }>(),
    Logout: emptyProps(),
    Init: emptyProps(),
    'Init Success': props<AuthSessionState>(),
    'Load Access Profile': props<{ navigateOnComplete: boolean }>(),
    'Load Access Profile Success': props<{ profile: AccessProfile; navigateOnComplete: boolean }>(),
    'Load Access Profile Failure': props<{ error: string; navigateOnComplete: boolean }>(),
    'Forgot Password': props<ForgotPasswordRequest>(),
    'Forgot Password Success': props<{ message: string }>(),
    'Forgot Password Failure': props<{ error: string }>(),
    'Clear Forgot Password Status': emptyProps(),
  },
});
